import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common'
import { z } from 'zod'

export const LocationSearchParamsSchema = z
  .object({
    q: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type LocationSearchParams = z.infer<typeof LocationSearchParamsSchema>

export const LocationSearchResultModelSchema = z.object({
  id: z.number(),
  code: z.string(),
})

export type LocationSearchResultModel = z.infer<
  typeof LocationSearchResultModelSchema
>

export const LocationSearchResultSchema = z
  .object({ data: z.array(LocationSearchResultModelSchema) })
  .merge(BasePaginateResultSchema)

export type LocationSearchResult = z.infer<typeof LocationSearchResultSchema>
